// Organization members for the alert recipients picker. One flow:
// GET /organization/mine -> GET /organization/:id/members. Absence of
// an org resolves to an empty member list (the section stays hidden).
const action = "DISCOVERY_ALERT_ORG_MEMBERS";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

export const fetchRequest = () => ({ type: REQUEST });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
